<template>
  <v-app id="app">
    <v-app-bar absolute>
    <!-- Left: Menu Icon -->
    <v-app-bar-nav-icon class="menu-btn" @click="drawer = true"></v-app-bar-nav-icon>

    <!-- Center: Logo and Title -->
    <v-spacer></v-spacer>
    <v-toolbar-title class="d-flex align-center justify-center">
      <v-img src="@/assets/logo_white.png" max-width="100px" class="mr-2"></v-img>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <!-- Right: User Avatar or Login Button -->
    <div class="d-flex align-center">
      <v-avatar color="indigo" v-if="user">
        <img :src="user.photoURL" />
      </v-avatar>
      <v-btn v-else @click="login">Sign Up / Login</v-btn>
    </div>
  </v-app-bar>
    <v-navigation-drawer
            v-model="drawer"
            absolute
            temporary
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Menu
          </v-list-item-title>
          <v-list-item-subtitle>

          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
              nav
              dense
      >
        <v-list-item-group
                active-class="deep-purple--text text--accent-4"
        >
          <v-list-item to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Home Page</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/properties">
            <v-list-item-icon>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Properties</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/data-insights">
            <v-list-item-icon>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Data Insights</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <v-container id="main-view" class="main-view">
        <v-progress-circular model-value="20" :size="66" color="primary" indeterminate v-if="isLoading" class="spinner"></v-progress-circular>
        <router-view v-else/>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
  import { authService } from "@/services/AuthService";
  import { sessionService  } from '@/services/SessionService';
  import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged } from "firebase/auth";

  export default {
    data: () => ({
      drawer: false,
      authorizationSet: false,
      authService: authService,
      sessionService: sessionService,
      user: null
    }),
    methods: {
      setUser: function (user) {        
        if (user) {
            authService.setUser(user);         
            this.authorizationSet = true;  
            this.$root.$emit('loginComplete')
        }
        this.user = user;
      },
      login: function () {
        const auth = getAuth();
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider)
        .then((result) => {
            this.setUser(result.user);
        }).catch((error) => {
            // Handle Errors here.
            console.log(error);
        });
      }
    },
    computed: {
      isLoading: {
        get: function() {
          return sessionService.isLoading;
        }
      }
    },
    created() {
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user) {
          this.setUser(user);
        } else {
          this.user = null;
          this.authorizationSet = false;
        }
      });
    }
  }
</script>
<style lang="scss">
  /* Crisp & Polished Rentals Dashboard Vuetify Theme (SCSS) */

  $primary-color: #1E88E5;       // Brighter Blue
  $secondary-color: #FFB300;     // Vivid Amber
  $accent-color: #43A047;        // Fresh Green
  $background-color: #F9FAFB;    // Soft Light Gray
  $text-color: #263238;          // Charcoal Gray
  $card-background: #FFFFFF;     // Pure White
  $border-radius: 12px;          // Slightly More Rounded
  $shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  $hover-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);

  body {
    background-color: $background-color;
    color: $text-color;
    font-family: 'Roboto', sans-serif;
    margin: 0;
    padding: 0;
    line-height: 1.6;
  }

  .v-application {
    background-color: $background-color !important;
  }

  .v-btn {
    background-color: white !important;
  }

  .menu-btn {
    background-color: $primary-color !important; 
    span, i, svg {
      color: white !important;
    } 
  }

  .v-card {
    background-color: $card-background !important;
    border-radius: $border-radius;
    box-shadow: $shadow;
    padding: 20px;
    transition: box-shadow 0.3s;

    &:hover {
      box-shadow: $hover-shadow;
    }
  }

  .v-toolbar {
    background-color: $primary-color !important;
    color: white !important;
    box-shadow: $shadow;
  }

  .v-data-table {
    background-color: $card-background !important;
    border-radius: $border-radius;
    box-shadow: $shadow;
    overflow: hidden;

    &-header th {
      background-color: $secondary-color !important;
      color: white !important;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  .v-chip {
    background-color: $accent-color !important;
    color: white !important;
    border-radius: $border-radius;
    font-weight: bold;
    padding: 6px 12px;
  }

  .v-navigation-drawer {
    background-color: $background-color !important;
    color: white !important;
    box-shadow: $shadow;
  }

  .v-list-item {
    color: white !important;
    transition: background-color 0.3s;

    &:hover {
      background-color: $secondary-color !important;
      color: $text-color !important;
    }
  }

  .v-footer {
    background-color: $primary-color !important;
    color: white !important;
    padding: 12px;
    text-align: center;
    box-shadow: $shadow;
  }

  .v-icon {
    color: $primary-color !important;
    transition: color 0.3s;

    &:hover {
      color: $secondary-color !important;
    }
  }

  #main-view {
    margin-top: 30px;
  }

  #spinner {
    margin-top: 300px;
  }

  .logo {
    /* Logo */
    padding-left: 5px;
  }

  .logo-row {
    align-items: end;
  }
</style>
